import {
  SAH_DELIVERY_LADDER,
  isSahDeliveryStatus,
  sahDeliveryStatusLabel,
} from './sah-delivery-ladder';

const SAFE_GENERIC_MESSAGE =
  'Support at Home funding and claims setup is incomplete. Care delivery should continue; contact your coordinator to resolve the financial hold.';

function errorMessage(error: unknown): string {
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    return typeof message === 'string' ? message : '';
  }
  return '';
}

function statusFromMessage(message: string): string | null {
  // Care-plan controlled RPC (web coordinator paths).
  const carePlanMatch = message.match(/sah_care_plan_not_delivery_ready:[^:\s]+:([A-Z_]+)/i);
  if (carePlanMatch?.[1]) return carePlanMatch[1].toUpperCase();

  // Service-delivery execution trigger (mobile start/complete path):
  // sah_service_delivery_not_delivery_ready:<care_plan_id>:<STATUS>
  const serviceMatch = message.match(/sah_service_delivery_not_delivery_ready:[^:\s]+:([A-Z_]+)/i);
  if (serviceMatch?.[1]) return serviceMatch[1].toUpperCase();

  const bareMatch = SAH_DELIVERY_LADDER.find((status) =>
    new RegExp(`(^|[^A-Z_])${status}([^A-Z_]|$)`, 'i').test(message),
  );
  return bareMatch ?? null;
}

/** True when a legacy RPC message carries a SAH financial-readiness token. */
export function isSahDeliveryBlockerError(error: unknown): boolean {
  const message = errorMessage(error).toLowerCase();
  return (
    message.includes('sah_care_plan_not_delivery_ready') ||
    message.includes('sah_service_delivery_not_delivery_ready')
  );
}

/** Human-readable legacy readiness failure for web, mobile, and book surfaces. */
export function mapSahDeliveryBlockerError(error: unknown): string {
  const message = errorMessage(error);
  const status = statusFromMessage(message);
  if (!isSahDeliveryStatus(status)) return SAFE_GENERIC_MESSAGE;

  return `Support at Home funding and claims are held: ${sahDeliveryStatusLabel(status)}. Care delivery should continue; contact your coordinator to resolve the financial setup.`;
}
